export default __webpack_public_path__ + "static/media/underdev.8b0912ff.png";